export interface Country {
  name: string;
  code: string;
  displayName: string;
}

export const COUNTRIES: Country[] = [
  { name: 'Andorra', code: 'AD', displayName: 'Andorra (AD)' },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    displayName: 'United Arab Emirates (AE)',
  },
  { name: 'Afghanistan', code: 'AF', displayName: 'Afghanistan (AF)' },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
    displayName: 'Antigua and Barbuda (AG)',
  },
  { name: 'Anguilla', code: 'AI', displayName: 'Anguilla (AI)' },
  { name: 'Albania', code: 'AL', displayName: 'Albania (AL)' },
  { name: 'Armenia', code: 'AM', displayName: 'Armenia (AM)' },
  {
    name: 'Netherlands Antilles',
    code: 'AN',
    displayName: 'Netherlands Antilles (AN)',
  },
  { name: 'Angola', code: 'AO', displayName: 'Angola (AO)' },
  { name: 'Antarctica', code: 'AQ', displayName: 'Antarctica (AQ)' },
  { name: 'Argentina', code: 'AR', displayName: 'Argentina (AR)' },
  { name: 'American Samoa', code: 'AS', displayName: 'American Samoa (AS)' },
  { name: 'Austria', code: 'AT', displayName: 'Austria (AT)' },
  { name: 'Australia', code: 'AU', displayName: 'Australia (AU)' },
  { name: 'Aruba', code: 'AW', displayName: 'Aruba (AW)' },
  { name: 'Åland Islands', code: 'AX', displayName: 'Åland Islands (AX)' },
  { name: 'Azerbaijan', code: 'AZ', displayName: 'Azerbaijan (AZ)' },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    displayName: 'Bosnia and Herzegovina (BA)',
  },
  { name: 'Barbados', code: 'BB', displayName: 'Barbados (BB)' },
  { name: 'Bangladesh', code: 'BD', displayName: 'Bangladesh (BD)' },
  { name: 'Belgium', code: 'BE', displayName: 'Belgium (BE)' },
  { name: 'Burkina Faso', code: 'BF', displayName: 'Burkina Faso (BF)' },
  { name: 'Bulgaria', code: 'BG', displayName: 'Bulgaria (BG)' },
  { name: 'Bahrain', code: 'BH', displayName: 'Bahrain (BH)' },
  { name: 'Burundi', code: 'BI', displayName: 'Burundi (BI)' },
  { name: 'Benin', code: 'BJ', displayName: 'Benin (BJ)' },
  {
    name: 'Saint Barthélemy',
    code: 'BL',
    displayName: 'Saint Barthélemy (BL)',
  },
  { name: 'Bermuda', code: 'BM', displayName: 'Bermuda (BM)' },
  {
    name: 'Brunei Darussalam',
    code: 'BN',
    displayName: 'Brunei Darussalam (BN)',
  },
  { name: 'Bolivia', code: 'BO', displayName: 'Bolivia (BO)' },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    code: 'BQ',
    displayName: 'Bonaire, Sint Eustatius and Saba (BQ)',
  },
  { name: 'Brazil', code: 'BR', displayName: 'Brazil (BR)' },
  { name: 'Bahamas', code: 'BS', displayName: 'Bahamas (BS)' },
  { name: 'Bhutan', code: 'BT', displayName: 'Bhutan (BT)' },
  { name: 'Bouvet Island', code: 'BV', displayName: 'Bouvet Island (BV)' },
  { name: 'Botswana', code: 'BW', displayName: 'Botswana (BW)' },
  { name: 'Belarus', code: 'BY', displayName: 'Belarus (BY)' },
  { name: 'Belize', code: 'BZ', displayName: 'Belize (BZ)' },
  { name: 'Canada', code: 'CA', displayName: 'Canada (CA)' },
  {
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
    displayName: 'Cocos (Keeling) Islands (CC)',
  },
  {
    name: 'Congo, Democratic Republic of the',
    code: 'CD',
    displayName: 'Congo, Democratic Republic of the (CD)',
  },
  {
    name: 'Central African Republic',
    code: 'CF',
    displayName: 'Central African Republic (CF)',
  },
  { name: 'Congo', code: 'CG', displayName: 'Congo (CG)' },
  { name: 'Switzerland', code: 'CH', displayName: 'Switzerland (CH)' },
  { name: "Côte d'Ivoire", code: 'CI', displayName: "Côte d'Ivoire (CI)" },
  { name: 'Cook Islands', code: 'CK', displayName: 'Cook Islands (CK)' },
  { name: 'Chile', code: 'CL', displayName: 'Chile (CL)' },
  { name: 'Cameroon', code: 'CM', displayName: 'Cameroon (CM)' },
  { name: 'China', code: 'CN', displayName: 'China (CN)' },
  { name: 'Colombia', code: 'CO', displayName: 'Colombia (CO)' },
  {
    name: 'Clipperton Island',
    code: 'CP',
    displayName: 'Clipperton Island (CP)',
  },
  { name: 'Costa Rica', code: 'CR', displayName: 'Costa Rica (CR)' },
  {
    name: 'Serbia and Montenegro',
    code: 'CS',
    displayName: 'Serbia and Montenegro (CS)',
  },
  { name: 'Cuba', code: 'CU', displayName: 'Cuba (CU)' },
  { name: 'Cabo Verde', code: 'CV', displayName: 'Cabo Verde (CV)' },
  { name: 'Curaçao', code: 'CW', displayName: 'Curaçao (CW)' },
  {
    name: 'Christmas Island',
    code: 'CX',
    displayName: 'Christmas Island (CX)',
  },
  { name: 'Cyprus', code: 'CY', displayName: 'Cyprus (CY)' },
  { name: 'Czechia', code: 'CZ', displayName: 'Czechia (CZ)' },
  { name: 'Germany', code: 'DE', displayName: 'Germany (DE)' },
  { name: 'Diego Garcia', code: 'DG', displayName: 'Diego Garcia (DG)' },
  { name: 'Djibouti', code: 'DJ', displayName: 'Djibouti (DJ)' },
  { name: 'Denmark', code: 'DK', displayName: 'Denmark (DK)' },
  { name: 'Dominica', code: 'DM', displayName: 'Dominica (DM)' },
  {
    name: 'Dominican Republic',
    code: 'DO',
    displayName: 'Dominican Republic (DO)',
  },
  { name: 'Algeria', code: 'DZ', displayName: 'Algeria (DZ)' },
  { name: 'Ceuta, Melilla', code: 'EA', displayName: 'Ceuta, Melilla (EA)' },
  { name: 'Ecuador', code: 'EC', displayName: 'Ecuador (EC)' },
  { name: 'Estonia', code: 'EE', displayName: 'Estonia (EE)' },
  { name: 'Egypt', code: 'EG', displayName: 'Egypt (EG)' },
  { name: 'Western Sahara', code: 'EH', displayName: 'Western Sahara (EH)' },
  { name: 'Eritrea', code: 'ER', displayName: 'Eritrea (ER)' },
  { name: 'Spain', code: 'ES', displayName: 'Spain (ES)' },
  { name: 'Ethiopia', code: 'ET', displayName: 'Ethiopia (ET)' },
  { name: 'European Union', code: 'EU', displayName: 'European Union (EU)' },
  { name: 'Neutral Zone', code: 'EZ', displayName: 'Neutral Zone (EZ)' },
  { name: 'Finland', code: 'FI', displayName: 'Finland (FI)' },
  { name: 'Fiji', code: 'FJ', displayName: 'Fiji (FJ)' },
  {
    name: 'Falkland Islands',
    code: 'FK',
    displayName: 'Falkland Islands (FK)',
  },
  { name: 'Micronesia', code: 'FM', displayName: 'Micronesia (FM)' },
  { name: 'Faroe Islands', code: 'FO', displayName: 'Faroe Islands (FO)' },
  { name: 'France', code: 'FR', displayName: 'France (FR)' },
  {
    name: 'France, Metropolitan',
    code: 'FX',
    displayName: 'France, Metropolitan (FX)',
  },
  { name: 'Gabon', code: 'GA', displayName: 'Gabon (GA)' },
  { name: 'United Kingdom', code: 'GB', displayName: 'United Kingdom (GB)' },
  { name: 'Grenada', code: 'GD', displayName: 'Grenada (GD)' },
  { name: 'Georgia', code: 'GE', displayName: 'Georgia (GE)' },
  { name: 'French Guiana', code: 'GF', displayName: 'French Guiana (GF)' },
  { name: 'Guernsey', code: 'GG', displayName: 'Guernsey (GG)' },
  { name: 'Ghana', code: 'GH', displayName: 'Ghana (GH)' },
  { name: 'Gibraltar', code: 'GI', displayName: 'Gibraltar (GI)' },
  { name: 'Greenland', code: 'GL', displayName: 'Greenland (GL)' },
  { name: 'Gambia', code: 'GM', displayName: 'Gambia (GM)' },
  { name: 'Guinea', code: 'GN', displayName: 'Guinea (GN)' },
  { name: 'Guadeloupe', code: 'GP', displayName: 'Guadeloupe (GP)' },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
    displayName: 'Equatorial Guinea (GQ)',
  },
  { name: 'Greece', code: 'GR', displayName: 'Greece (GR)' },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
    displayName: 'South Georgia and the South Sandwich Islands (GS)',
  },
  { name: 'Guatemala', code: 'GT', displayName: 'Guatemala (GT)' },
  { name: 'Guam', code: 'GU', displayName: 'Guam (GU)' },
  { name: 'Guinea-Bissau', code: 'GW', displayName: 'Guinea-Bissau (GW)' },
  { name: 'Guyana', code: 'GY', displayName: 'Guyana (GY)' },
  { name: 'Hong Kong', code: 'HK', displayName: 'Hong Kong (HK)' },
  {
    name: 'Heard Island and McDonald Islands',
    code: 'HM',
    displayName: 'Heard Island and McDonald Islands (HM)',
  },
  { name: 'Honduras', code: 'HN', displayName: 'Honduras (HN)' },
  { name: 'Croatia', code: 'HR', displayName: 'Croatia (HR)' },
  { name: 'Haiti', code: 'HT', displayName: 'Haiti (HT)' },
  { name: 'Hungary', code: 'HU', displayName: 'Hungary (HU)' },
  { name: 'Iceland', code: 'IC', displayName: 'Iceland (IC)' },
  { name: 'Indonesia', code: 'ID', displayName: 'Indonesia (ID)' },
  { name: 'Ireland', code: 'IE', displayName: 'Ireland (IE)' },
  { name: 'Israel', code: 'IL', displayName: 'Israel (IL)' },
  { name: 'Isle of Man', code: 'IM', displayName: 'Isle of Man (IM)' },
  { name: 'India', code: 'IN', displayName: 'India (IN)' },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
    displayName: 'British Indian Ocean Territory (IO)',
  },
  { name: 'Iraq', code: 'IQ', displayName: 'Iraq (IQ)' },
  { name: 'Iran', code: 'IR', displayName: 'Iran (IR)' },
  { name: 'Iceland', code: 'IS', displayName: 'Iceland (IS)' },
  { name: 'Italy', code: 'IT', displayName: 'Italy (IT)' },
  { name: 'Jersey', code: 'JE', displayName: 'Jersey (JE)' },
  { name: 'Jamaica', code: 'JM', displayName: 'Jamaica (JM)' },
  { name: 'Jordan', code: 'JO', displayName: 'Jordan (JO)' },
  { name: 'Japan', code: 'JP', displayName: 'Japan (JP)' },
  { name: 'Kenya', code: 'KE', displayName: 'Kenya (KE)' },
  { name: 'Kyrgyzstan', code: 'KG', displayName: 'Kyrgyzstan (KG)' },
  { name: 'Cambodia', code: 'KH', displayName: 'Cambodia (KH)' },
  { name: 'Kiribati', code: 'KI', displayName: 'Kiribati (KI)' },
  { name: 'Comoros', code: 'KM', displayName: 'Comoros (KM)' },
  {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
    displayName: 'Saint Kitts and Nevis (KN)',
  },
  { name: 'North Korea', code: 'KP', displayName: 'North Korea (KP)' },
  { name: 'South Korea', code: 'KR', displayName: 'South Korea (KR)' },
  { name: 'Kuwait', code: 'KW', displayName: 'Kuwait (KW)' },
  { name: 'Cayman Islands', code: 'KY', displayName: 'Cayman Islands (KY)' },
  { name: 'Kazakhstan', code: 'KZ', displayName: 'Kazakhstan (KZ)' },
  { name: 'Laos', code: 'LA', displayName: 'Laos (LA)' },
  { name: 'Lebanon', code: 'LB', displayName: 'Lebanon (LB)' },
  { name: 'Saint Lucia', code: 'LC', displayName: 'Saint Lucia (LC)' },
  { name: 'Liechtenstein', code: 'LI', displayName: 'Liechtenstein (LI)' },
  { name: 'Sri Lanka', code: 'LK', displayName: 'Sri Lanka (LK)' },
  { name: 'Liberia', code: 'LR', displayName: 'Liberia (LR)' },
  { name: 'Lesotho', code: 'LS', displayName: 'Lesotho (LS)' },
  { name: 'Lithuania', code: 'LT', displayName: 'Lithuania (LT)' },
  { name: 'Luxembourg', code: 'LU', displayName: 'Luxembourg (LU)' },
  { name: 'Latvia', code: 'LV', displayName: 'Latvia (LV)' },
  { name: 'Libya', code: 'LY', displayName: 'Libya (LY)' },
  { name: 'Morocco', code: 'MA', displayName: 'Morocco (MA)' },
  { name: 'Monaco', code: 'MC', displayName: 'Monaco (MC)' },
  { name: 'Moldova', code: 'MD', displayName: 'Moldova (MD)' },
  { name: 'Montenegro', code: 'ME', displayName: 'Montenegro (ME)' },
  {
    name: 'Saint Martin (French part)',
    code: 'MF',
    displayName: 'Saint Martin (French part) (MF)',
  },
  { name: 'Madagascar', code: 'MG', displayName: 'Madagascar (MG)' },
  {
    name: 'Marshall Islands',
    code: 'MH',
    displayName: 'Marshall Islands (MH)',
  },
  { name: 'North Macedonia', code: 'MK', displayName: 'North Macedonia (MK)' },
  { name: 'Mali', code: 'ML', displayName: 'Mali (ML)' },
  { name: 'Myanmar', code: 'MM', displayName: 'Myanmar (MM)' },
  { name: 'Mongolia', code: 'MN', displayName: 'Mongolia (MN)' },
  { name: 'Macao', code: 'MO', displayName: 'Macao (MO)' },
  { name: 'Martinique', code: 'MQ', displayName: 'Martinique (MQ)' },
  { name: 'Mauritania', code: 'MR', displayName: 'Mauritania (MR)' },
  { name: 'Montserrat', code: 'MS', displayName: 'Montserrat (MS)' },
  { name: 'Malta', code: 'MT', displayName: 'Malta (MT)' },
  { name: 'Mauritius', code: 'MU', displayName: 'Mauritius (MU)' },
  { name: 'Maldives', code: 'MV', displayName: 'Maldives (MV)' },
  { name: 'Malawi', code: 'MW', displayName: 'Malawi (MW)' },
  { name: 'Mexico', code: 'MX', displayName: 'Mexico (MX)' },
  { name: 'Malaysia', code: 'MY', displayName: 'Malaysia (MY)' },
  { name: 'Mozambique', code: 'MZ', displayName: 'Mozambique (MZ)' },
  { name: 'Namibia', code: 'NA', displayName: 'Namibia (NA)' },
  { name: 'New Caledonia', code: 'NC', displayName: 'New Caledonia (NC)' },
  { name: 'Niger', code: 'NE', displayName: 'Niger (NE)' },
  { name: 'Norfolk Island', code: 'NF', displayName: 'Norfolk Island (NF)' },
  { name: 'Nigeria', code: 'NG', displayName: 'Nigeria (NG)' },
  { name: 'Nicaragua', code: 'NI', displayName: 'Nicaragua (NI)' },
  { name: 'Netherlands', code: 'NL', displayName: 'Netherlands (NL)' },
  { name: 'Norway', code: 'NO', displayName: 'Norway (NO)' },
  { name: 'Nepal', code: 'NP', displayName: 'Nepal (NP)' },
  { name: 'Nauru', code: 'NR', displayName: 'Nauru (NR)' },
  { name: 'Neutral Zone', code: 'NT', displayName: 'Neutral Zone (NT)' },
  { name: 'Niue', code: 'NU', displayName: 'Niue (NU)' },
  { name: 'New Zealand', code: 'NZ', displayName: 'New Zealand (NZ)' },
  { name: 'Oman', code: 'OM', displayName: 'Oman (OM)' },
  { name: 'Panama', code: 'PA', displayName: 'Panama (PA)' },
  { name: 'Peru', code: 'PE', displayName: 'Peru (PE)' },
  {
    name: 'French Polynesia',
    code: 'PF',
    displayName: 'French Polynesia (PF)',
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
    displayName: 'Papua New Guinea (PG)',
  },
  { name: 'Philippines', code: 'PH', displayName: 'Philippines (PH)' },
  { name: 'Pakistan', code: 'PK', displayName: 'Pakistan (PK)' },
  { name: 'Poland', code: 'PL', displayName: 'Poland (PL)' },
  {
    name: 'Saint Pierre and Miquelon',
    code: 'PM',
    displayName: 'Saint Pierre and Miquelon (PM)',
  },
  { name: 'Pitcairn', code: 'PN', displayName: 'Pitcairn (PN)' },
  { name: 'Puerto Rico', code: 'PR', displayName: 'Puerto Rico (PR)' },
  {
    name: 'Palestine, State of',
    code: 'PS',
    displayName: 'Palestine, State of (PS)',
  },
  { name: 'Portugal', code: 'PT', displayName: 'Portugal (PT)' },
  { name: 'Palau', code: 'PW', displayName: 'Palau (PW)' },
  { name: 'Paraguay', code: 'PY', displayName: 'Paraguay (PY)' },
  { name: 'Qatar', code: 'QA', displayName: 'Qatar (QA)' },
  { name: 'Réunion', code: 'RE', displayName: 'Réunion (RE)' },
  { name: 'Romania', code: 'RO', displayName: 'Romania (RO)' },
  { name: 'Serbia', code: 'RS', displayName: 'Serbia (RS)' },
  {
    name: 'Russian Federation',
    code: 'RU',
    displayName: 'Russian Federation (RU)',
  },
  { name: 'Rwanda', code: 'RW', displayName: 'Rwanda (RW)' },
  { name: 'Saudi Arabia', code: 'SA', displayName: 'Saudi Arabia (SA)' },
  { name: 'Solomon Islands', code: 'SB', displayName: 'Solomon Islands (SB)' },
  { name: 'Seychelles', code: 'SC', displayName: 'Seychelles (SC)' },
  { name: 'Sudan', code: 'SD', displayName: 'Sudan (SD)' },
  { name: 'Sweden', code: 'SE', displayName: 'Sweden (SE)' },
  { name: 'Finland', code: 'SF', displayName: 'Finland (SF)' },
  { name: 'Singapore', code: 'SG', displayName: 'Singapore (SG)' },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    code: 'SH',
    displayName: 'Saint Helena, Ascension and Tristan da Cunha (SH)',
  },
  { name: 'Slovenia', code: 'SI', displayName: 'Slovenia (SI)' },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ',
    displayName: 'Svalbard and Jan Mayen (SJ)',
  },
  { name: 'Slovakia', code: 'SK', displayName: 'Slovakia (SK)' },
  { name: 'Sierra Leone', code: 'SL', displayName: 'Sierra Leone (SL)' },
  { name: 'San Marino', code: 'SM', displayName: 'San Marino (SM)' },
  { name: 'Senegal', code: 'SN', displayName: 'Senegal (SN)' },
  { name: 'Somalia', code: 'SO', displayName: 'Somalia (SO)' },
  { name: 'Suriname', code: 'SR', displayName: 'Suriname (SR)' },
  { name: 'South Sudan', code: 'SS', displayName: 'South Sudan (SS)' },
  {
    name: 'Sao Tome and Principe',
    code: 'ST',
    displayName: 'Sao Tome and Principe (ST)',
  },
  { name: 'Soviet Union', code: 'SU', displayName: 'Soviet Union (SU)' },
  { name: 'El Salvador', code: 'SV', displayName: 'El Salvador (SV)' },
  { name: 'Sint Maarten', code: 'SX', displayName: 'Sint Maarten (SX)' },
  {
    name: 'Syrian Arab Republic',
    code: 'SY',
    displayName: 'Syrian Arab Republic (SY)',
  },
  { name: 'Eswatini', code: 'SZ', displayName: 'Eswatini (SZ)' },
  {
    name: 'Tristan da Cunha',
    code: 'TA',
    displayName: 'Tristan da Cunha (TA)',
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC',
    displayName: 'Turks and Caicos Islands (TC)',
  },
  { name: 'Chad', code: 'TD', displayName: 'Chad (TD)' },
  {
    name: 'French Southern Territories',
    code: 'TF',
    displayName: 'French Southern Territories (TF)',
  },
  { name: 'Togo', code: 'TG', displayName: 'Togo (TG)' },
  { name: 'Thailand', code: 'TH', displayName: 'Thailand (TH)' },
  { name: 'Tajikistan', code: 'TJ', displayName: 'Tajikistan (TJ)' },
  { name: 'Tokelau', code: 'TK', displayName: 'Tokelau (TK)' },
  { name: 'Timor-Leste', code: 'TL', displayName: 'Timor-Leste (TL)' },
  { name: 'Turkmenistan', code: 'TM', displayName: 'Turkmenistan (TM)' },
  { name: 'Tunisia', code: 'TN', displayName: 'Tunisia (TN)' },
  { name: 'Tonga', code: 'TO', displayName: 'Tonga (TO)' },
  { name: 'East Timor', code: 'TP', displayName: 'East Timor (TP)' },
  { name: 'Turkey', code: 'TR', displayName: 'Turkey (TR)' },
  {
    name: 'Trinidad and Tobago',
    code: 'TT',
    displayName: 'Trinidad and Tobago (TT)',
  },
  { name: 'Tuvalu', code: 'TV', displayName: 'Tuvalu (TV)' },
  { name: 'Taiwan', code: 'TW', displayName: 'Taiwan (TW)' },
  {
    name: 'Tanzania, United Republic of',
    code: 'TZ',
    displayName: 'Tanzania, United Republic of (TZ)',
  },
  { name: 'Ukraine', code: 'UA', displayName: 'Ukraine (UA)' },
  { name: 'Uganda', code: 'UG', displayName: 'Uganda (UG)' },
  { name: 'United Kingdom', code: 'UK', displayName: 'United Kingdom (UK)' },
  {
    name: 'United States Minor Outlying Islands',
    code: 'UM',
    displayName: 'United States Minor Outlying Islands (UM)',
  },
  {
    name: 'United States of America',
    code: 'US',
    displayName: 'United States of America (US)',
  },
  { name: 'Uruguay', code: 'UY', displayName: 'Uruguay (UY)' },
  { name: 'Uzbekistan', code: 'UZ', displayName: 'Uzbekistan (UZ)' },
  { name: 'Holy See', code: 'VA', displayName: 'Holy See (VA)' },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
    displayName: 'Saint Vincent and the Grenadines (VC)',
  },
  { name: 'Venezuela', code: 'VE', displayName: 'Venezuela (VE)' },
  {
    name: 'Virgin Islands, British',
    code: 'VG',
    displayName: 'Virgin Islands, British (VG)',
  },
  {
    name: 'Virgin Islands, U.S.',
    code: 'VI',
    displayName: 'Virgin Islands, U.S. (VI)',
  },
  { name: 'Vietnam', code: 'VN', displayName: 'Vietnam (VN)' },
  { name: 'Vanuatu', code: 'VU', displayName: 'Vanuatu (VU)' },
  {
    name: 'Wallis and Futuna',
    code: 'WF',
    displayName: 'Wallis and Futuna (WF)',
  },
  { name: 'Samoa', code: 'WS', displayName: 'Samoa (WS)' },
  { name: 'Neutral Zone', code: 'XA', displayName: 'Neutral Zone (XA)' },
  { name: 'Neutral Zone', code: 'XB', displayName: 'Neutral Zone (XB)' },
  { name: 'Neutral Zone', code: 'XI', displayName: 'Neutral Zone (XI)' },
  { name: 'Kosovo', code: 'XK', displayName: 'Kosovo (XK)' },
  { name: 'Yemen', code: 'YE', displayName: 'Yemen (YE)' },
  { name: 'Mayotte', code: 'YT', displayName: 'Mayotte (YT)' },
  { name: 'Yugoslavia', code: 'YU', displayName: 'Yugoslavia (YU)' },
  { name: 'South Africa', code: 'ZA', displayName: 'South Africa (ZA)' },
  { name: 'Zambia', code: 'ZM', displayName: 'Zambia (ZM)' },
  { name: 'Zaire', code: 'ZR', displayName: 'Zaire (ZR)' },
  { name: 'Zimbabwe', code: 'ZW', displayName: 'Zimbabwe (ZW)' },
];
